import {
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import { useFormDeliveryFeeController } from './controller/form';
import ConfirmDialog from '../../components/ConfirmDialog';
import { DeliveryFeeModel } from '../../models/deliveryFee';
import { useTranslation } from 'react-i18next';

interface Props {
  onClose: Function,
  selectedData: DeliveryFeeModel
  setSelectedData: Function
  onFetchData: Function
}

const FormDeliveryFee = ({ onClose, selectedData, setSelectedData, onFetchData }: Props) => {
  const controller = useFormDeliveryFeeController({ selectedData, onClose, setSelectedData, onFetchData });
  const { t } = useTranslation('global');

  return (
    <form onSubmit={(e) => controller.handleOpenConfirmForm(e)}>
      <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight="bold">
        {selectedData ? t('deliveryFee_page.Edit delivery area fee') : t('deliveryFee_page.Add delivery area fee')}
      </Typography>
      <Box
        sx={{
          p: 4,
          boxShadow:
            '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
          borderRadius: '10px',
          maxWidth: 600,
          mt: 1
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Box sx={{ width: '100%' }}>
              <Typography>{t("deliveryFee_page.Area name")}</Typography>
              <TextField
                fullWidth
                placeholder={`${t("deliveryFee_page.Enter Name Delivery Fee")}`}
                margin='normal'
                required
                inputRef={controller.areaName}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ width: '100%' }}>
              <Typography>{t("deliveryFee_page.Base delivery Price")}</Typography>
              <TextField
                fullWidth
                placeholder={`${t("deliveryFee_page.Enter Base Delivery Fee Price")}`}
                margin='normal'
                required
                inputRef={controller.basePrice}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ width: '100%' }}>
              <Typography>{t("deliveryFee_page.Extra delivery Price")}</Typography>
              <TextField
                fullWidth
                placeholder={`${t("deliveryFee_page.Enter Extra Delivery Fee Price")}`}
                margin='normal'
                required
                inputRef={controller.extraPrice}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ width: '100%' }}>
              <Typography>{t("deliveryFee_page.limit distance")}</Typography>
              <TextField
                fullWidth
                placeholder={`${t("deliveryFee_page.Enter Base Delivery Fee Distance")}`}
                margin='normal'
                required
                inputRef={controller.limitDistance}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ width: '100%' }}>
              <Typography>{t("deliveryFee_page.Extra distance")}</Typography>
              <TextField
                fullWidth
                placeholder={`${t("deliveryFee_page.Enter Extra Delivery Fee Distance")}`}
                margin='normal'
                required
                inputRef={controller.extraDistance}
              />
            </Box>
          </Grid>
        </Grid>
        {controller.errorMessage && <Typography color='error'>{controller.errorMessage}</Typography>}
        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
          <Button variant='outlined' onClick={() => { onClose(); controller.handleReset() }} color='error' sx={{ textTransform: 'none', borderRadius: '10px', mr: 1, width: '100px' }}>
            {t("Cancel")}
          </Button>
          <Button type='submit' sx={{ textTransform: 'none', background: '#11A2F1', borderRadius: '10px' }} variant="contained">
            {selectedData ? t('deliveryFee_page.Update Delivery Fee') : t('deliveryFee_page.Create Delivery Fee')}
          </Button>
        </Box>
      </Box>

      <ConfirmDialog
        open={controller.openConfirm}
        title={`${selectedData ? t('Do you want to update this data ?') : t('Do you want to create this data ?')} `}
        loading={controller.loadingConfirmButton}
        onCancel={controller.handleCloseConfirmForm}
        onConfirm={() => controller.handleSubmit()}
      />
    </form>
  );
};
export default FormDeliveryFee;
